import { render, staticRenderFns } from "./DeviceTagComp.vue?vue&type=template&id=e9d8763a&scoped=true&"
import script from "./DeviceTagComp.vue?vue&type=script&lang=js&"
export * from "./DeviceTagComp.vue?vue&type=script&lang=js&"
import style0 from "./DeviceTagComp.vue?vue&type=style&index=0&id=e9d8763a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d8763a",
  null
  
)

export default component.exports